import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, ActionSheetController } from 'ionic-angular';
import { FeedData } from '../../providers/feed-data';
import { UserData } from '../../providers/user-data';
import { Utils } from '../../providers/utils';
import { ModalPostSubmit } from '../../components/modal-post-submit';
import { ModalMediaSubmit } from '../../components/modal-media-submit';
import { ModalCommentSubmit } from '../../components/modal-comment-submit'; 
import { ModalShareSubmit } from '../../components/modal-share-submit'; 
import { EventCodes } from '../../core/codes';
import { AppSettings } from '../../config/app-settings';
import { Camera } from 'ionic-native';
import { AccountPage } from '../../modules/account/pages/account/account';
import { Helpers } from '../../providers/helpers';
import _ from 'lodash';

declare var window: any;
declare var cordova: any;
declare var navigator: any;

@Component({
    selector: 'page-user-feed',
    templateUrl: 'user-feed.html'
})
export class UserFeedPage {
    public postsData = [];
    public timelineUser: any;
    public items: any;
    public isShowingSuggestedKeywords: boolean = false;
    public currentUser: any;
    public modal: any;
    public isLoadingTimeLine: boolean = true;
    public loading: any;
    public hasNewPost: boolean = false;
    private newPost: any;
    private tasksToLoad: number = 0;

    constructor(
        private nav: NavController, 
        public params: NavParams,
        private helpers: Helpers,
        private userData: UserData,
        private feedData: FeedData,
        private events: Events,        
        private settings: AppSettings,
        private modalController: ModalController,
        private actionsheetController: ActionSheetController
    ) {
        this.timelineUser = this.params.get("timelineUser");
        this.updateLike(null, true);
        console.log(this.timelineUser);
    }

    ionViewDidEnter() {
        var self = this;
        // Load from cache fist
        self.isLoadingTimeLine = true;
        
        this.userData.hasLoggedIn().subscribe((isLoggedIn) => {
            if(isLoggedIn){
                self.feedData.getAllOfflinePostsByUser(self.timelineUser.uid).subscribe((offlinePosts) => {
                    if(offlinePosts != null) {
                        console.log("Showing offline data first");
                        self.postsData = offlinePosts;
                    }
                });
                self.userData.getUser().subscribe((user) => {
                    self.currentUser = user;
                    self.loadTimeLine();
                    
                });
            }else{
                self.isLoadingTimeLine = false;
            }
        });
        
        this.events.subscribe(EventCodes.POST_SUBMITTED, (_newPost)=>{
            if(_newPost && _newPost.length > 0){
                // console.log(_newPost[0]);
                self.newPost = _newPost[0].post;
                if(_newPost[0].media){
                    self.newPost.media = _newPost[0].media.value;
                    // console.log(self.newPost.media);
                }
                self.postsData.unshift(self.newPost);
            }
            setTimeout(()=>{
                self.closeModals();    
            },100);
            
        });

        this.events.subscribe(EventCodes.POST_SUBMITTED_ERROR, ()=>{
            setTimeout(()=>{
                self.closeModals();    
            },100);
        });
        
    }

    private closeModals(){
        var self = this;
        if(self.modal){
            console.log("Post Submitted. Try to close any modal");

            self.modal.dismiss().then(function(){
                console.log("Modal dismissed");
            });    
        }
    }

    public openPostModal(){
        this.modal = this.modalController.create(ModalPostSubmit, {user: this.currentUser});
        this.modal.present();
    }

    public openMediaModal(mediaFile){
        console.log("opening media modal");
        this.modal = this.modalController.create(ModalMediaSubmit, {mediaUri: mediaFile, user: this.currentUser});
        this.modal.present();
    }

    public openCommentModal(post){
        console.log("opening comment modal");
        this.modal = this.modalController.create(ModalCommentSubmit, {post: post, user: this.currentUser});
        this.modal.present();
    }

    public openShareModal(post){
        console.log("opening share modal");
        this.modal = this.modalController.create(ModalShareSubmit, {post: post, user: this.currentUser});
        this.modal.present();
    }

    private loadTimeLine(){
        console.log("reloading timeline");
        var self = this;
        
        this.feedData.getAllPostsByUser(self.timelineUser.uid, this.settings.postsPerPage).subscribe(posts => {
            if(posts != null) {
                self.postsData = posts;                
                self.loadPostData();
                console.log("Post Loaded");
                self.newPost = self.postsData[0];
                self.hasNewPost = false;
                self.events.publish(EventCodes.POST_LOADED);
            } else {
                self.isLoadingTimeLine = false;
            }            
        }); 
    }

    private loadPostData(){
        let self=this;
        self.postsData.forEach(post =>{
            if(post.value.hasMedia){
                self.tasksToLoad ++;
                self.feedData.getPostMedia(post.key).subscribe(media => {
                    media.viewCount ++;
                    post.media = media;

                    //Update counts back to Firebase
                    self.feedData.updatePostMedia(post.key, media).subscribe(result=>{
                        //console.log("Updated count for media", result);
                    });

                    self.tasksToLoad --;
                    self.storePostData();
                });
            }

            if(post.value.likeCount > 0){
                self.tasksToLoad ++;
                self.feedData.getPostLikes(post.key).subscribe(likeUsers => {
                    post.likes = likeUsers;
                    self.tasksToLoad --;
                    self.storePostData();
                });
            }

            if(post.value.commentCount > 0){
                self.tasksToLoad ++;
                self.feedData.getPostComments(post.key, this.settings.commentsPerPage).subscribe(comments => {
                    post.comments = comments;
                    self.tasksToLoad --;
                    self.storePostData();
                });
            }
        });
        
        self.isLoadingTimeLine = false;
    }

    private storePostData(){
        if(this.tasksToLoad == 0){
            console.log("Done loading. Storing for user timeline");
            this.feedData.setAllOfflinePostsByUser(this.timelineUser.uid, this.postsData);
        }
    } 

    public onSearchBarFocus (ev){
        this.isShowingSuggestedKeywords = true;
    }

    public onSearchBarBlur(ev){
        this.isShowingSuggestedKeywords = false;
    }

    public getNameInitials(name){
        return Utils.getFirstInitials(name);
    }

    public formatNum(num){
        if(!num){return "";}
        return Utils.formatNumberToString(num);
    }

    // Post Media section

    public addMedia(){
        let actionSheet = this.actionsheetController.create({
            title: '',
            buttons: [
              {
                text: 'Take a new picture',
                handler: () => {
                  this.openCamera('photo');
                }
              },
              // {
              //   text: 'Record a video',
              //   handler: () => {
              //     this.openCamera('video');
              //   }
              // },
              {
                text: 'Import from phone',
                handler: () => {
                  this.openCamera('library');
                }
              },
              {
                text: 'Cancel',
                role: 'cancel',
                handler: () => {
                  console.log('Cancel clicked');
                }
              }
            ]
        });
        actionSheet.present();
    }

    private setCameraOptions(srcType){
        var options = {
            // Some common settings are 20, 50, and 100
            quality: 80,
            destinationType: Camera.DestinationType.FILE_URI,
            // In this app, dynamically set the picture source, Camera or photo gallery
            sourceType: srcType,
            encodingType: Camera.EncodingType.JPEG,
            mediaType: Camera.MediaType.PICTURE,
            allowEdit: true,
            correctOrientation: true  //Corrects Android orientation quirks
        }
        return options;
    }
    
    private openCamera(selection) {
        let self = this;
        let srcType = {};

        self.showLoading();

        if (selection=="photo"){
            srcType = Camera.PictureSourceType.CAMERA;
        }else{
            srcType = Camera.PictureSourceType.PHOTOLIBRARY;
        }

        var options = this.setCameraOptions(srcType);

        navigator.camera.getPicture(function cameraSuccess(mediaUri) {
            console.log("Got fileUri from phone");
            self.hideLoading();
            self.loading.onDidDismiss(() => {
                self.openMediaModal(mediaUri);
            }); 
        }, function cameraError(error) {
            console.debug("Unable to obtain picture: " + error, "app");
        }, options);
    }

    private updateLike(post, isLike){
        //Update LikeCount back to Firebase
        if (!post){return;}
        let self = this;

        if(isLike){
            post.value.likeCount ++;
        }else{
            if(post.value.likeCount > 0){post.value.likeCount --;}
        }
        this.feedData.updatePostLike(post.key, self.currentUser.uid, post.value, isLike, this.myLike(post)).subscribe(result=>{
            if(isLike){
                if(result!=false){
                    if(post.likes == null){post.likes = [];}
                    post.likes.push({
                        key:result, 
                        value: {uid:self.currentUser.uid}
                    })
                }
            }else{
                post.likes = _.reject(post.likes, function(userLike){
                    let uLike:any = userLike;
                    return uLike.value.uid == self.currentUser.uid;
                });
            }
            console.log("Updated Like Count for post", result);
        });
    }

    public myLike(post){
        let self = this;
        return _.find(post.likes, function(likeUser){
            let lUser:any = likeUser;
            return lUser.value.uid == self.currentUser.uid;
        });
    }

    public showLoading(){
        this.loading = this.helpers.showLoading();
    }

    public hideLoading(){
        this.helpers.hideLoading();
    }

    public getTimeSince(unixTime){
        return Utils.timeSince(unixTime);
    }

    public goToPage(page){
        switch (page) {
            case "account":
                this.nav.push(AccountPage);
                break;
            
            default:
                // code...
                break;
        }
    }

    public loadUserFeed(timelineUser){
        this.nav.push(UserFeedPage, {timelineUser: timelineUser});
    }
}



// WEBPACK FOOTER //
// ./src/pages/feed/user-feed.ts